import { getStatusType, STATUS_TYPE } from './statusConsts';

export const PACING_SCORE_STATUS = {
    HIGHLY_UNDER_PACING: 'HIGHLY_UNDER_PACING',
    UNDER_PACING: 'UNDER_PACING',
    ON_TRACK: 'ON_TRACK',
    OVER_PACING: 'OVER_PACING',
    HIGHLY_OVER_PACING: 'HIGHLY_OVER_PACING',
};

const pacingScoreStatusConsts = {
    [PACING_SCORE_STATUS.HIGHLY_UNDER_PACING]: { statusType: STATUS_TYPE.DANGER },
    [PACING_SCORE_STATUS.UNDER_PACING]: { statusType: STATUS_TYPE.WARNING },
    [PACING_SCORE_STATUS.ON_TRACK]: { statusType: STATUS_TYPE.SUCCESS },
    [PACING_SCORE_STATUS.OVER_PACING]: { statusType: STATUS_TYPE.WARNING },
    [PACING_SCORE_STATUS.HIGHLY_OVER_PACING]: { statusType: STATUS_TYPE.DANGER },
};

export const getPacingScoreStatusType = pacingScoreStatus => getStatusType(pacingScoreStatusConsts, pacingScoreStatus);
